var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/retake_selfie.de6a441b.png","uri@2x": __webpack_public_path__ + "static/media/retake_selfie.06f297b2.png","uri@3x": __webpack_public_path__ + "static/media/retake_selfie.25a7ce7e.png",
    width: 14,
    height: 15
});